<template>
  <div
    class="index_page"
    v-watermark="{
      text: appMobilePhone,
      textColor: 'rgba(180, 180, 180, 0.3)',
    }"
  >
    <div class="container">
      <div class="header" />
      <div class="content_container">
        <div
          class="flex1 top_2"
          v-watermark="{
            text: appMobilePhone,
            textColor: 'rgba(180, 180, 180, 0.3)',
          }"
        >
          <div
            class="content_title1"
            style="font-size: 24px; margin-left: 30px"
          >
            莲藕医生（药店端）
          </div>
          <div class="flex3 content_header">
            <div class="shop_name" v-if="shopName.length > 0">
              欢迎您！{{ shopName
              }}{{
                shopType == 0
                  ? "(连锁总部)"
                  : shopType == 1
                  ? "(连锁门店)"
                  : "(单体药店)"
              }}
            </div>
            <div class="shop_name" v-else>请关联店铺后登录</div>
            <div class="flex2 shopList">
              <Dropdown @on-click="changeShop">
                <a href="javascript:void(0)">
                  切换
                  <Icon type="ios-arrow-down"></Icon>
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem
                    :name="item.ShopName"
                    :selected="item.sel"
                    v-for="(item, i) in shopList"
                    :key="i"
                    >{{ item.ShopName
                    }}{{
                      item.ShopType == 0
                        ? "(连锁总部)"
                        : item.ShopType == 1
                        ? "(连锁门店)"
                        : "(单体药店)"
                    }}</DropdownItem
                  >
                </DropdownMenu>
                <!-- 药店类型（0：连锁总部 1：连锁门店 2：单体药店） -->
              </Dropdown>
            </div>
            <div class="exit_btn" @click="showExit = true">退出</div>
          </div>
          <!-- <div class="flex2 pointer">
            <img src="../img/click.png" alt class="content_img1" />
            <div class="content_tip1">点击下载药店端APP</div>
          </div>-->
        </div>
        <div class="content_index1_img">
          <img src="../img/index_111.png" />
        </div>
        <div class="contnet_tab">
          <div
            class="flex2 tab_item"
            style="position: relative"
            v-watermark="{
              text: appMobilePhone,
              textColor: 'rgba(180, 180, 180, 0.3)',
            }"
          >
            <div
              :class="
                tabIndex == item.status
                  ? 'doctor_list_text avtive_title1'
                  : 'doctor_list_text'
              "
              v-for="(item, index) in tabList"
              :key="item.title"
              @click="changeTab(item.status, index)"
            >
              {{ item.title }}
            </div>
            <div
              v-show="showSpace"
              class="inquiry_recording_search_spcel pointer"
              @click="handelAppoint"
            >
              指定药品处方免费
            </div>
          </div>
          <!-- <div v-if="tabIndex==0">
            <div class="flex2 doctor_status">
              <div class="fixed_width">医生状态</div>
              <div class="margin_right20">:</div>
              <div
                :class="item.sel?'doctor_status_item select_item_active':'doctor_status_item' "
                v-for="(item,index) in doctorStatus"
                :key="item.title"
                @click="selectCondition({type:1,index:index})changeDotorPage(item.code)"
              >{{item.title}}</div>
          </div>-->

          <div
            class="department doctor_classification"
            style="display: flex; padding-top: 2px"
            v-if="tabIndex == 0"
          >
            <div class="depar">
              <div class="fixed_width margin_right20">科室：</div>
            </div>
            <div
              style="float: left"
              v-watermark="{
                text: appMobilePhone,
                textColor: 'rgba(180, 180, 180, 0.3)',
              }"
            >
              <div
                :class="
                  item.sel
                    ? 'department_item select_item_active'
                    : 'department_item'
                "
                v-for="(item, index) in doctorClass"
                :key="item.title"
                @click="
                  selectCondition({ type: 2, index: index, code: item.code })
                "
                style="white-space: nowrap; float: left"
              >
                {{ item.title }}
              </div>
            </div>
          </div>

          <!--  <div class="flex2 doctor_classification">
              <div class="fixed_width">医生分类</div>
              <div class="margin_right20">:</div>
              <div
                :class="item.sel?'doctor_classification_item select_item_active':'doctor_classification_item' "
                v-for="(item,index) in doctorClassification"
                :key="item.title"
                @click="selectCondition({type:3,index:index})"
              >{{item.title}}</div>
            </div>
          </div>-->
        </div>
        <div class="doclist flex2" v-if="tabIndex == 0">
          <div v-if="docList.length > 0" class="doclist flex2">
            <div
              class="doctor_item pos1"
              v-for="item in docList"
              :key="item.Name"
              v-watermark="{
                text: appMobilePhone,
                textColor: 'rgba(180, 180, 180, 0.3)',
              }"
            >
              <!-- <div class="people_num">排队人数 0</div> -->
              <img
                :src="item.PicUrl || doctorsHead"
                alt
                class="doctor_avatar_img"
              />
              <div class="flex2 flex4 doctor_name_power">
                <div>{{ item.Name }}</div>
                <div>{{ item.Professional }}</div>
              </div>
              <div class="flex2 flex4 doctor_class_language">
                <div>{{ item.Department }}</div>
                <div>{{ item.Language || "普通话" }}</div>
              </div>
              <div class="is_hospital">互联网医院</div>
              <div class="good_at line4">{{ item.GoodAt }}</div>

              <div class="online_consultation_btn" @click="checkifPackage(1)">
                在线问诊
              </div>
            </div>
            <div style="text-align: center; width: 100%; margin-bottom: 30px">
              <Page
                :total="PageTotalD"
                :page-size="9"
                style="text-align: center"
                @on-change="pageChangeD"
              />
            </div>
            <!-- Count: 2
            Department: "全科医疗科"
            DoctorId: "test002"
            GoodAt: null
            Hospital: null
            Language: null
            Name: "冲龄"
            PicUrl: ""
            Professional: "主任医师"
            Sex: "1"-->
          </div>
          <div v-else class="z-box">
            <div class="p-50">
              <div>
                <img src="../img/z.png" alt />
              </div>
              <div class="font-w">当前科室暂无医生在线</div>
              <div class="font-w">点击快速问诊，系统将为您自动推荐好医生</div>
              <div>
                <!-- rapidInterrogation // -->
                <div class="k-btn" @click="checkifPackage(2)">快速问诊</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 问诊已完成记录 -->
        <!-- <div
          class="inquiry_recording"
          v-if="tabIndex==1"
          v-watermark="{text:appMobilePhone,textColor:'rgba(180, 180, 180, 0.3)'}"
        >
          <div class="flex2">
        <div class="flex2">-->
        <!-- <div class="fixed_width72">提交时间：</div> -->
        <!-- <Date-picker
                type="date"
                placeholder="选择日期"
                :value="filterCondition.createDate"
                style="width:147px;margin-right:34px"
                :editable="false"
                @on-change="createDateChange"
        ></Date-picker>-->
        <!-- <Date-picker
                type="daterange"
                split-panels
                placeholder="选择日期"
                :value="filterCondition.createDate"
                style="width:180px;margin-right:34px;height:32px;"
                :editable="false"
                @on-change="createDateChange"
        ></Date-picker>-->
        <!-- change -->
        <!-- <input type="text" placeholder="例如：2019-01-01" v-model="filterCondition.createDate" /> -->
        <!-- </div>

            <div class="flex2">
              <div class="fixed_width72">患者姓名：</div>
              <input type="text" v-model="filterCondition.name" style="width:180px;" />
            </div>

            <div class="flex2" v-if="totalShop">
              <div class="fixed_width72">来源门店：</div>
              <input type="text" v-model="filterCondition.sourceName" style="width:180px;" />
            </div>

            <div class="flex2">
              <label for="inquiry_recording" class="fixed_width72">问诊方式：</label>
              <select
                id="inquiry_recording"
                class="select_inquiry_recording"
                v-model="filterCondition.selectModel"
                style="width:180px;"
              >
                <option>全部</option>
                <option>图文问诊</option>
                <option>视频问诊</option>
              </select>
            </div>
          </div>

          <div class="flex2 margin_top26 margin_bottom26">
            <div class="fixed_width72">手机号：</div>
            <input type="tel" maxlength="11" v-model="filterCondition.mobile" style="width:180px;" />

            <div class="flex2" v-if="totalShop">
              <label for="inquiry_recording" class="fixed_width72">状态：</label>
              <select
                id="inquiry_recording"
                class="select_inquiry_recording"
                v-model="filterCondition.prescriptionStatus"
                style="width:180px;"
              >
                <option>全部</option>
                <option>等待接诊</option>
                <option>接诊中</option>
                <option>已开方</option>
                <option>已拒绝</option>
              </select>
            </div>
            <div class="inquiry_recording_search_btn pointer" @click="filterSearchInquiry">查询</div>
          </div>
          <Table :columns="tableColumns" :data="tableData" border style="margin-bottom:20px"></Table>
          <Page :total="PageTotal" style="text-align:center" @on-change="pageChange" />
        </div>-->
        <div
          class="inquiry_recording"
          v-if="tabIndex == 4"
          v-watermark="{
            text: appMobilePhone,
            textColor: 'rgba(180, 180, 180, 0.3)',
          }"
        >
          <inquiry-not
            :childStoreList="childStoreList"
            @clickKeep="checkifPackage"
            @clickRefuseResult="clickRefuseResult"
            @clickInquiryDetail="clickInquiryDetail"
            @clickSeePrescription="clickSeePrescription"
          ></inquiry-not>
        </div>
        <div
          class="inquiry_recording"
          v-if="tabIndex == 2"
          v-watermark="{
            text: appMobilePhone,
            textColor: 'rgba(180, 180, 180, 0.3)',
          }"
        >
          <histori-cal
            :shopTypeChild="shopType"
            :childStoreList="childStoreList"
          ></histori-cal>
        </div>
        <div
          class="inquiry_recording"
          v-if="tabIndex == 3"
          v-watermark="{
            text: appMobilePhone,
            textColor: 'rgba(180, 180, 180, 0.3)',
          }"
        >
          <shop-list-table :childStoreList="childStoreList"></shop-list-table>
        </div>
      </div>
      <div class="footer">
        <div class="footer_email_mobile">
          合作咨询：王集富:15920570383 邮箱:764058491@qq.com
        </div>
        <div class="copy_that">
          &copy;版权所有 2019 广东莲藕健康科技有限公司. All Rights Reserved
        </div>
      </div>
      <!-- 33333333333333333 -->
      <div class="mask1" v-if="showFillModule">
        <div
          class="fill_module1 trans"
          v-watermark="{
            text: appMobilePhone,
            textColor: 'rgba(180, 180, 180, 0.3)',
          }"
        >
          <div class="fill_edit pos1">
            <div class="edit_car">就诊人信息填写卡</div>
            <div class="close_x pointer" @click="changeFillStatus">
              <img src="../img/x.png" class="x-size" />
            </div>
          </div>
          <div style="padding-left: 150px">
            <Steps :current="current">
              <Step content="填写就诊人信息"></Step>
              <Step content="填写疾病用药信息"></Step>
              <Step content="提交问诊"></Step>
            </Steps>
          </div>

          <div class="fill_people" v-if="current == 0">
            <div class="fill_title">填写就诊人信息</div>
            <div class="padding_left20 fill_left">
              <div class="flex1">
                <div class="flex2">
                  <div class="flex2">
                    <span class="must_fill_tip">*</span>
                    <div
                      class="fixed_width55"
                      οnkeyup="value=value.replace(/[^\u4E00-\u9FA5]/g,'')"
                    >
                      姓名
                    </div>
                  </div>
                  <div>:</div>
                  <input type="text" v-model="details.name" />
                </div>
                <div class="flex2">
                  <div class="flex2">
                    <div class="fixed_width65">
                      <span class="must_fill_tip">*</span>
                      <span class="must_fill_tip"></span>身份证号
                    </div>
                  </div>
                  <div>:</div>
                  <input
                    type="text"
                    v-model="details.carId"
                    @input="getCarId"
                    maxlength="18"
                  />
                </div>
              </div>
              <div class="flex1">
                <div class="flex2">
                  <div class="flex2">
                    <span class="must_fill_tip">*</span>
                    <div class="fixed_width55">性别</div>
                    <div style="margin-right: 8px">:</div>
                  </div>
                  <RadioGroup v-model="details.sex" @on-change="checkGridorMan">
                    <Radio :label="0" :disabled="disableSex">男</Radio>
                    <Radio :label="1" :disabled="disableSex">女</Radio>
                  </RadioGroup>
                </div>
                <div class="flex2">
                  <div class="flex2">
                    <span class="must_fill_tip">*</span>
                    <div class="fixed_width55">手机号</div>
                  </div>
                  <div>:</div>
                  <input type="text" v-model="details.mobile" maxlength="11" />
                </div>
                <!-- <div class="flex2">
                  <div class="flex2">
                    <div class="fixed_width65">
                      <span class="must_fill_tip">*</span>出生年月
                    </div>
                  </div>
                  <div>:</div>
                  <Date-picker
                    type="date"
                    placeholder="选择日期"
                    :value="details.birthday"
                    style="width: 162px;margin-left:8px"
                    :editable="false"
                    @on-change="birstdayChange"
                  ></Date-picker>
                </div>-->
              </div>
              <div class="flex1" v-show="isShowWeight">
                <!-- <div class="flex2">
                  <div class="flex2">
                    <span class="must_fill_tip">*</span>
                    <div class="fixed_width55">手机号</div>
                  </div>
                  <div>:</div>
                  <input type="text" v-model="details.mobile" maxlength="11" />
                </div>-->
                <div class="flex2 pos1">
                  <div class="flex2">
                    <span class="must_fill_tip">*</span>
                    <div class="fixed_width65">体重</div>
                  </div>
                  <div>:</div>
                  <input
                    type="text"
                    id="weight_input"
                    placeholder="14岁以下必填"
                    v-model="details.weight"
                  />
                  <div class="kg">千克</div>
                </div>
              </div>
            </div>
            <div class="sel_history">
              <div class="fill_title">疾病史</div>
              <div class="six_disease">
                <div class="flex2">
                  <div class="fixed_width70">
                    <span class="must_fill_tip">*</span>过往病史：
                  </div>
                  <RadioGroup v-model="details.PMHType">
                    <Radio :label="0" class="radiowidth">无</Radio>
                    <Radio :label="1">有</Radio>
                  </RadioGroup>
                  <input
                    type="text"
                    v-show="details.PMHType == 1"
                    v-model="details.PMHDesc"
                    style="width: 380px"
                  />
                </div>

                <div class="flex2">
                  <div class="fixed_width70">
                    <span class="must_fill_tip">*</span>过敏史：
                  </div>
                  <RadioGroup v-model="details.AMHType">
                    <Radio :label="0" class="radiowidth">无</Radio>
                    <Radio :label="1">有</Radio>
                  </RadioGroup>
                  <input
                    type="text"
                    v-show="details.AMHType == 1"
                    v-model="details.AMHDesc"
                    style="width: 380px"
                  />
                </div>

                <div class="flex2">
                  <div class="fixed_width70">
                    <span class="must_fill_tip">*</span>家族病史：
                  </div>
                  <RadioGroup v-model="details.FMHType">
                    <Radio :label="0" class="radiowidth">无</Radio>
                    <Radio :label="1">有</Radio>
                  </RadioGroup>
                  <input
                    type="text"
                    v-show="details.FMHType == 1"
                    v-model="details.FMHDesc"
                    style="width: 380px"
                  />
                </div>

                <div class="flex2" v-show="details.sex != 0">
                  <div class="fixed_width70">
                    <span class="must_fill_tip">*</span>妊娠哺乳：
                  </div>
                  <RadioGroup v-model="details.NurseType">
                    <Radio :label="0" class="radiowidth">无</Radio>
                    <Radio :label="2">备孕中</Radio>
                    <Radio :label="3">怀孕中</Radio>
                    <Radio :label="4">正在哺乳</Radio>
                  </RadioGroup>
                </div>
                <div class="flex2" v-show="details.sex == 0">
                  <div class="fixed_width70">
                    <span class="must_fill_tip">*</span>备孕中：
                  </div>
                  <RadioGroup v-model="details.NurseType">
                    <Radio :label="0" class="radiowidth">无</Radio>
                    <Radio :label="2">有</Radio>
                  </RadioGroup>
                </div>

                <div class="flex2">
                  <div class="fixed_width70">
                    <span class="must_fill_tip">*</span>肝功能：
                  </div>
                  <RadioGroup v-model="details.LiverType">
                    <Radio :label="0">正常</Radio>
                    <Radio :label="1">异常</Radio>
                  </RadioGroup>
                </div>

                <div class="flex2">
                  <div class="fixed_width70">
                    <span class="must_fill_tip">*</span>肾功能：
                  </div>
                  <RadioGroup v-model="details.RenalType">
                    <Radio :label="0">正常</Radio>
                    <Radio :label="1">异常</Radio>
                  </RadioGroup>
                </div>
              </div>
              <div class="next_1 pointer" @click="next(0)">下一步</div>
            </div>
          </div>
          <div class="add_drug_module" v-if="current == 1">
            <div class="fill_title">用药信息</div>
            <div class="flex2">
              <div><span class="must_fill_tip">*</span>既往用药：</div>
              <div class="add_drug_btn pointer" @click="addPast">+ 添加</div>
            </div>
            <table border="1">
              <tr class="table_th">
                <th>通用名</th>
                <th>规格</th>
                <th>数量</th>
                <th>选择主要用药（单选）</th>
                <th>操作</th>
              </tr>
              <tr v-for="(item, index) in details.DrugsList" :key="item.DrugId">
                <td>{{ item.ComName || item.CommonName }}</td>
                <td>{{ item.Specs }}</td>
                <td class="flex2 flex4">
                  <input
                    type="tel"
                    class="input_drug_num"
                    max="99"
                    maxlength="2"
                    v-model="item.Count"
                  />
                  <div>{{ item.Unit || item.CountUnit }}</div>
                </td>
                <td>
                  <Radio
                    v-model="item.IsMainSel"
                    @on-change="isMainChange(item, index)"
                  ></Radio>
                </td>
                <td>
                  <div class="pointer" @click="dele(item, index)">
                    <img src="../img/del.png" class="imag-size mi-icon" />
                    <span class="span-color mi-icon">删除</span>
                  </div>
                </td>
              </tr>
            </table>
            <!-- 删除确认弹窗 -->
            <Modal
              title="删除"
              v-model="showdelete"
              @on-ok="configDele(deleteIndex)"
              class-name="vertical-center-modal"
            >
              <p>
                确认删除，{{ deleteItem.ComName || deleteItem.CommonName }}？
              </p>
            </Modal>
            <div class="flex2">
              <div style="flex: 0 0 auto">
                <span class="must_fill_tip">*</span>线下已确诊疾病：
              </div>
              <CheckboxGroup v-model="confirmedDisease" @on-change="limetThree">
                <Checkbox
                  :label="item.DiseaseName"
                  v-for="item in drugDiseaseList"
                  :key="item.Name"
                ></Checkbox>
              </CheckboxGroup>
              <div
                class="add_drug_btn search_dis_btn pointer"
                @click="addchange"
              >
                添加
              </div>
            </div>
            <div>
              <div class="flex2 img_upload1">
                <div>病历上传：</div>
                <Upload
                  multiple
                  accept="image/*"
                  :headers="headerUpload"
                  :action="UploadUrl"
                  :show-upload-list="false"
                  :data="uploadData"
                  name="ShopPic"
                  :before-upload="uploadBefore"
                  :on-success="uploadSuccess"
                >
                  <Button icon="ios-cloud-upload-outline">上传病历</Button>
                </Upload>
              </div>
              <div class="flex2">
                <div
                  class="upLoadImgSee pos1"
                  v-for="(item, index) in details.PicList"
                  :key="item.Url"
                >
                  <img :src="item.Url" />
                  <img
                    src="@/img/delete.png"
                    alt
                    class="delete_img1 pointer"
                    @click="deleteUploadImg(index)"
                  />
                </div>
              </div>
            </div>
            <div class="flex2">
              <div><span class="must_fill_tip">*</span>请选择问诊方式：</div>
              <Radio v-model="questioningMethod">图文问诊</Radio>
              <Radio disabled style="color: #b9b9b9"
                >视频问诊（仅支持APP使用）</Radio
              >
            </div>
            <div class="flex2 agreen_module">
              <Checkbox v-model="agreeAgreement">我已阅读并同意</Checkbox>
              <router-link
                tag="a"
                target="_blank"
                :to="{ name: 'protocol', query: { type: '1' } }"
                class="protocol pointer"
                >《知情同意书》</router-link
              >
              <router-link
                tag="a"
                target="_blank"
                :to="{ name: 'protocol', query: { type: '2' } }"
                class="protocol pointer"
                >《莲藕互联网医院服务协议》</router-link
              >
            </div>
            <div class="double_btn flex2">
              <div class="pointer previous_btn" @click="current = 0">
                上一步
              </div>
              <div class="pointer submit_inquiry_btn" @click="submitInquiry">
                提交问诊
              </div>
            </div>
          </div>
          <div v-if="current == 2">
            <div class="success_tip_img">
              <img src="@/img/5_03.png" alt />
            </div>
            <div class="success_tip_text1">已提交</div>
            <div class="success_tip_text2">
              医生可能会通过电话与你进行详细沟通，请保持电话畅通
            </div>
            <div class="goto_details pointer" @click="gotoInquiryDetail">
              查看问诊记录
            </div>
            <div class="close_tip">3S后关闭该窗口</div>
          </div>
        </div>
        <div class="mask1" v-if="showSeachMobule">
          <div class="search_drug_module trans">
            <div class="fill_title1 pos1">
              <div>添加药品</div>
              <div class="close_x pointer" @click="showSeachMobule = false">
                <img src="../img/x.png" class="x-size" />
              </div>
            </div>
            <div class="flex2 search_drug_value_box">
              <div class="pos1">
                <img src="@/img/1_10.png" class="search_drug_img" />
                <input
                  type="search"
                  placeholder="搜索通用名添加药品"
                  v-model="searchDrugValue"
                  class="search_input"
                  v-on:keyup.enter="submitSearch(0)"
                />
                <div class="search_drug_input pointer" @click="submitSearch(0)">
                  搜索
                </div>
              </div>
              <!-- <div class="add_drug_btn1 pointer">搜索不到？新增药品</div> -->
            </div>
            <table border="1" cellspacing="0">
              <tr class="table_th">
                <th>通用名</th>
                <th>规格</th>
                <th>操作</th>
              </tr>
              <tr v-for="(item, index) in searchDrugList" :key="item.DrugId">
                <td>{{ item.ComName }}</td>
                <td>{{ item.Specs }}</td>
                <td>
                  <div
                    class="add_drug_list pointer"
                    @click="addSearchDrug(item, index)"
                    v-if="!item.sel"
                  >
                    +添加
                  </div>
                  <div
                    class="cannel_drug_list pointer"
                    v-if="item.sel"
                    @click="cannelAddDrug(item, index)"
                  >
                    x 取消
                  </div>
                </td>
              </tr>

              <tr v-if="searchDrugList.length == 0">
                <td colspan="3" height="40px" style="border: 1px solid #f2f2f2">
                  暂无数据
                </td>
              </tr>
            </table>
            <div class="flex1">
              <Page
                :total="drugTotal"
                :page-size="5"
                style="margin: 0 auto; text-align: center"
                @on-change="searchDrugPageChange"
              />
              <div class="flex2 select_drug_box">
                <div class="select_drug_num">
                  已选择{{ details.DrugsList.length }}
                </div>
                <div
                  class="select_drug_box_submit pointer"
                  @click="showSeachMobule = false"
                >
                  确定
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mask1" v-if="showDisModule">
        <div class="search_dis_module trans">
          <div class="fill_title1 pos1">
            <div>疾病搜索</div>
            <div class="close_x pointer" @click="showDisModule = false">
              <img src="../img/x.png" class="x-size" />
            </div>
          </div>
          <div class="flex2 search_dis_input_box">
            <input
              type="text"
              class="search_dis_input"
              v-model="searchDisValue"
            />
            <div class="pointer search_btn_style" @click="searchDis">搜索</div>
          </div>
          <table border="1" class>
            <tr>
              <th>疾病名称</th>
              <th>状态</th>
            </tr>
            <tr v-for="(item, index) in searchDiseaseList" :key="item.Name">
              <td>{{ item.Name }}</td>
              <td>
                <div
                  class="add_drug_list pointer"
                  @click="addDis(item, index)"
                  v-if="!item.sel"
                >
                  +添加
                </div>
                <div
                  class="cannel_drug_list pointer"
                  v-if="item.sel"
                  @click="deleteDis(item, index)"
                >
                  x 取消
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <!-- 问诊详情 -->
      <div class="mask1" v-if="showInquiryDetail">
        <div
          class="inquiry_detail_module trans"
          v-watermark="{
            text: appMobilePhone,
            textColor: 'rgba(180, 180, 180, 0.3)',
          }"
        >
          <div class="fill_title1 pos1">
            <div>问诊详情</div>
            <div class="close_x pointer" @click="showInquiryDetail = false">
              <img src="../img/x.png" class="x-size" />
            </div>
          </div>

          <div class="flex2 flex4 inquiry_detail_module_title">
            <div class="title_2">
              当前状态：{{
                consultationDetails.Status == 0
                  ? "等待接诊"
                  : consultationDetails.Status == 1
                  ? "等待接诊"
                  : consultationDetails.Status == 3
                  ? "接诊中"
                  : consultationDetails.Status == 5
                  ? "已开方"
                  : "已拒绝"
              }}
            </div>
            <div class="pic_inquiry_type">
              {{ consultationDetails.ModeType == 1 ? "图文问诊" : "视频问诊" }}
            </div>
          </div>

          <div class="detail_box">
            <div class="title_3">用药人信息</div>
            <div class="flex2 details_box_1">
              <div class="d_pixed_width1 flex2">
                <div class="fixed_width2">姓名</div>
                <div>：{{ consultationDetails.Name }}</div>
              </div>
              <div class="flex2">
                <div class="fixed_width2">身份证号：</div>
                <div>
                  {{
                    isShowEnCode ? mingCode.IDCard : consultationDetails.IDCard
                  }}
                </div>
                <div class="look_all_info" @click="getEncodeData">
                  查看完整信息
                </div>
              </div>
            </div>

            <div class="flex2 details_box_1">
              <div class="d_pixed_width1 flex2">
                <div class="fixed_width2">性别</div>
                <div>：{{ consultationDetails.Sex == 1 ? "男" : "女" }}</div>
              </div>
              <div class="flex2">
                <div class="fixed_width2">出生年月</div>
                <div>：{{ consultationDetails.Age }}</div>
              </div>
            </div>

            <div class="flex2 details_box_1">
              <div class="d_pixed_width1 flex2">
                <div class="fixed_width2">手机号</div>
                <div>
                  ：{{
                    isShowEnCode
                      ? mingCode.MobilePhone
                      : consultationDetails.PhoneNo
                  }}
                </div>
              </div>
              <div class="flex2">
                <div class="fixed_width2">体重</div>
                <div>：{{ consultationDetails.Weight || "---" }}kg</div>
              </div>
            </div>
          </div>
          <div class="detail_box">
            <div class="title_3">疾病史</div>
            <!-- AMHDesc过敏史  NurseDesc是否怀孕 -->
            <div class="dis_text">
              {{
                consultationDetails.AMHType == 0
                  ? ""
                  : consultationDetails.AMHDesc == null
                  ? ""
                  : "过敏史：" + consultationDetails.AMHDesc + " "
              }}
              {{
                consultationDetails.FMHType == 0
                  ? ""
                  : consultationDetails.FMHDesc == null
                  ? ""
                  : "家族病史：" + consultationDetails.FMHDesc + " "
              }}
              {{
                consultationDetails.NurseType == 0
                  ? ""
                  : consultationDetails.NurseDesc == null
                  ? ""
                  : "妊娠哺乳：" + consultationDetails.NurseDesc + " "
              }}
              {{
                consultationDetails.PMHType == 0
                  ? ""
                  : consultationDetails.PMHDesc == null
                  ? ""
                  : "过往病史：" + consultationDetails.PMHDesc + " "
              }}
              肝功能：{{
                consultationDetails.LiverType == 0 ? "正常" : "异常"
              }}， 肾功能：{{
                consultationDetails.RenalType == 0 ? "正常" : "异常"
              }}
            </div>
          </div>
          <div class="detail_box">
            <div class="title_3">疾病信息</div>
            <div class="flex2 dis_text" style="align-items: stretch">
              <div style="white-space: nowrap">线下已确诊疾病：</div>
              <div class="flex2 flex2-wrap">
                <div
                  v-for="item in consultationDetails.DiseaseList"
                  :key="item.id"
                >
                  <div style="white-space: nowrap">{{ item.Name }}</div>
                </div>
              </div>
            </div>
            <div class="flex2 medicalRecordImg">
              <div>病历：</div>
              <div v-if="consultationDetails.PicList.length > 0">
                <viewer :images="consultationDetails.PicList">
                  <img
                    v-for="item in consultationDetails.PicList"
                    :src="item.Url"
                    :key="item.Url"
                    class="detail_img pointer"
                  />
                </viewer>
              </div>
              <div v-else>无</div>
            </div>
          </div>

          <div class="detail_box">
            <!-- <img
              src="@/img/chat_doc.png"
              class="chat_doc_img"
              @click="gotoChatOrHis"
              v-if="chatStatus!=3"
            />-->
            <div class="title_3">药品信息</div>
            <table v-if="!isCNUpcCode" border="1" class="show_drug_table">
              <tr>
                <th>序号</th>
                <th>药品名称</th>
                <th >规格</th>
                <th>数量</th>
              </tr>
              <tr
                v-for="(item, index) in consultationDetails.DrugsList"
                :key="item.DrugId"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ item.CommonName }}</td>
                <td>{{ item.Specs }}</td>
                <td>{{ item.Count + item.CountUnit }}</td>
              </tr>
            </table>
            <table v-if="isCNUpcCode" border="1" class="show_drug_table">
              <tr>
                <th>序号</th>
                <th>方剂名称</th>
                <th>数量</th>
              </tr>
              <tr
                v-for="(item, index) in consultationDetails.DrugsList"
                :key="item.DrugId"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ item.CommonName }}</td>
                <td>{{ item.Count + item.CountUnit }}</td>
              </tr>
            </table>
          </div>
          <!-- <div
            class="change_btn"
            @click="changeDetail(consultationDetails)"
            v-if="consultationDetails.Status !==5 && consultationDetails.Status !==3 &&shopName == oneCompanyName"
          >
            <div class="pointer">修改</div>
          </div>-->
        </div>
      </div>
    </div>
    <!-- 查看处方 -->
    <div class="mask1" v-if="showViewPrescription">
      <div class="view_prescription_module trans">
        <div class="fill_title1 pos1">
          <div>查看处方</div>
          <div class="close_x pointer" @click="showViewPrescription = false">
            <img src="../img/x.png" class="x-size" />
          </div>
        </div>
        <div class="prescription_img_box">
          <viewer :images="OrderFileUrl">
            <section ref="print">
              <img :src="OrderFileUrl" class="pointer" />
            </section>
          </viewer>
        </div>
        <div class="view_pre_double_btn flex2">
          <div class="pointer" @click="printInquiryImg">打印处方</div>
          <div class="pointer" @click="downloads">保存处方</div>
        </div>
      </div>
    </div>
    <!--套餐详情-->
    <div v-if="appintShow">
      <Modal v-model="appintShow" width="50%">
        <p
          slot="header"
          style="
            text-align: center;
            font-size: 18px;
            font-weight: bold;
            color: #ffffff;
          "
        >
          <span>套餐详情</span>
        </p>
        <AppointFeel></AppointFeel>
        <div slot="footer">
          <Button @click="appintShow = false">取消</Button>
        </div>
      </Modal>
    </div>

    <!-- 查看处方 -->
    <div class="mask1" v-if="lookShop">
      <look-Prescription
        @lookModule="closeModule"
        @noeModules="oneKeySignature"
        :InquiryId="rowInquiryId"
      ></look-Prescription>
    </div>
    <!-- 一键签名 -->
    <div class="mask1" v-if="oneShop">
      <one-signature
        @noeModules="closeoneModule"
        :InquiryId="rowInquiryId"
        :signaNum="signaNum"
      ></one-signature>
    </div>
    <!-- 拒绝原因 -->
    <div class="mask1" v-if="showRefuse">
      <div
        class="view_prescription_module trans"
        style="width: 400px; height: 500px"
      >
        <div class="fill_title1 pos1">
          <div>拒绝原因</div>
          <div class="close_x pointer" @click="showRefuse = false">
            <img src="../img/x.png" class="x-size" />
          </div>
        </div>
        <div
          class="tip1_module_content_1"
          style="text-align: start; padding: 0 20px; word-wrap: break-word"
        >
          {{ DealDesc }}
        </div>
      </div>
    </div>
    <div class="mask1" v-if="showTip1">
      <tip-one @showFillModule="changeFillStatus('new')"></tip-one>
    </div>
    <Modal
      title="退出"
      v-model="showExit"
      @on-ok="submitExit"
      class-name="vertical-center-modal"
    >
      <p>您确定要退出登录吗</p>
    </Modal>
    <Modal
      title="提示"
      v-model="showConfigDis"
      @on-ok="showConfigDis == false"
      class-name="vertical-center-modal"
    >
      <p>线下已确诊疾病,最多只能选择三个！</p>
    </Modal>
    <chat v-if="$store.state.showChat"></chat>
    <!-- <simulated-chat></simulated-chat> -->
    <!-- 历史聊天记录 -->
    <history-chat
      v-if="$store.state.showHisChat"
      :inquiryId="hisInquiryId"
    ></history-chat>

    <!-- 微信扫码提单弹框 -->
    <Modal v-model="showWxSubMit" :styles="{ top: '20px' }">
      <p slot="header" style="color: #ffffff; text-align: center">
        <span>请打开微信“扫一扫”进行问诊</span>
      </p>
      <div style="text-align: center">
        <img src="../img/oldqocode.png" height="700" />
        <img class="qrcoe_size" :src="openQiCode" width="340" />
      </div>
      <div slot="footer">
        <Button size="large" @click="showWxSubMit = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  EditSwichEnterprise,
  GetDiseaseList,
  GetDoctorList,
  // GetInquiryList,
  GetDrugsList,
  SaveInquiry,
  GetInquiry,
  GetOrder,
  ShopList,
  APP_baseUrl,
  UpdateInquiry,
  GetPrescriptionInfo,
  GetGroupMsg,
  GetDiagnoseByComNames,
  SavePatient,
  GetInquiryPicCode,
  GetChildShopList,
  GetPackage,
  GetShopPackage,
  GetInquiryEncodeData,
  GetInquiryWxOpenQrCode_Base64,
} from "@/utils/api.js";
import { clearAllCookie, getAge } from "@/utils/common.js";
import { Radio, Alert, Divider, Toast } from "iview";
import { getCookie, setCookie, cloneObj, delCookie } from "@/utils/common.js";
import axios from "axios";
import SHA1 from "sha1";
import HistoriCal from "@/components/historical";
import lookPrescription from "@/components/lookPrescription";
import oneSignature from "@/components/onekeySignature";
import shopListTable from "@/components/shopList";
import inquiryNot from "@/components/inquiryNot";
import tipOne from "@/components/tip1";
import chat from "@/components/chat";
// import simulatedChat from "@/components/simulatedChat"
import historyChat from "@/components/history_chat";
import AppointFeel from "@/components/appointFeel";
export default {
  components: {
    tipOne,
    HistoriCal,
    shopListTable,
    lookPrescription,
    oneSignature,
    inquiryNot,
    chat,
    historyChat,
    AppointFeel,
    // simulatedChat
  },
  computed: {
    isCNUpcCode() {
      let isShow = false;
      if (JSON.stringify(this.consultationDetails) != "{}") {
        this.consultationDetails.DrugsList.map(item=>{
         isShow =  item.CNUpcCode?true:false;
        })
      }
      return isShow
    },
  },
  data() {
    return {
      openQiCode: "", //微信二维码路径
      showWxSubMit: false, //是否显示微信二维码弹框
      mingCode: [], //明码数据
      isShowEnCode: false, //是否显示身份证明码
      showSpace: false,
      appintShow: false, //套餐详情的显示
      signaNum: 0, //签名的个数
      isShowWeight: false,
      childStoreList: [],
      disableSex: false, //性别是否禁止选中
      groupID: "",
      doctorsHead: require("../img/1_03.png"),
      chatStatus: 0,
      hisInquiryId: "",
      oneShop: false,
      appMobilePhone: "SDFASF",
      rowInquiryId: "",
      lookShop: false,
      updata: false, //问诊详情更新修改
      showTip1: false,
      shopType: localStorage.getItem("extendType"),
      totalShop: false, //访问的是连锁总部的时候显示的筛选条件
      shopList: [],
      showDisModule: false,
      searchDiseaseList: [], //搜索疾病列表
      showConfigDis: false,
      searchDisValue: "", // 搜索疾病关键词

      filterCondition: {
        // 筛选条件
        selectModel: "全部",
        createDate: ["", ""],
        name: "",
        mobile: "",
        sourceName: "",
        prescriptionStatus: "全部",
      },

      showExit: false, //退出模块
      showdelete: false, //删除确认弹框
      deleteItem: [], //删除既往用药的内容
      deleteIndex: "", //删除下标
      OrderFileUrl: "", //处方图片
      consultationDetails: {}, //问诊详情数据
      InquiryId: "",
      submitInquiryIng: false, //提交问诊中？
      showViewPrescription: false,
      showInquiryDetail: false,
      uploadData: {},
      questioningMethod: true, //图文问诊
      UploadUrl: process.env.VUE_APP_APPV3 + "Shop/UploadShopPic",
      uploadBeforemsg: null,
      headerUpload: {
        uniqueId: getCookie("uniqueId"),
        access_token: getCookie("access_token"),
      },
      showSeachMobule: false, //显示搜索药品接口
      searchDrugList: [],
      searchDrugValue: "",
      originData: {
        name: "",
        carId: "",
        sex: 2,
        birthday: "",
        mobile: "",
        weight: "",
        ModeType: 1, //问诊方式  1为图文 3为语音   5为视频
        PMHType: 0, //过往病史 0=无；1=有；
        PMHDesc: "",
        AMHType: 0, //过敏史0=无；1=有；
        AMHDesc: "",
        FMHType: 0, //家族病史
        FMHDesc: "",
        NurseType: 0, //是否妊娠哺乳0=无；1=有；
        NurseDesc: "",
        LiverType: 0, //肝功能异常0=无；1=有；
        LiverDesc: "",
        RenalType: 0, //肾功能异常0=无；1=有；
        RenalDesc: "",
        DiseaseList: [], //DiseaseId症状ID
        DrugsList: [], //DrugId Count
        PicList: [],
        SubmitType: 5, //app问诊还是扫码问诊
      },
      details: {
        name: "",
        carId: "",
        sex: 2,
        birthday: "",
        mobile: "",
        weight: "",
        ModeType: 1, //问诊方式  1为图文 3为语音   5为视频
        PMHType: 0, //过往病史 0=无；1=有；
        PMHDesc: "",
        AMHType: 0, //过敏史0=无；1=有；
        AMHDesc: "",
        FMHType: 0, //家族病史
        FMHDesc: "",
        NurseType: 0, //是否妊娠哺乳0=无；1=有；
        NurseDesc: "",
        LiverType: 0, //肝功能异常0=无；1=有；
        LiverDesc: "",
        RenalType: 0, //肾功能异常0=无；1=有；
        RenalDesc: "",
        DiseaseList: [], //DiseaseId症状ID
        DrugsList: [], //DrugId Count
        PicList: [],
        SubmitType: 5, //app问诊还是扫码问诊
      },
      PageTotal: 0, //问诊记录总条数
      page: 1,
      drugPage: 1,
      drugTotal: 0, //药品总条数
      shopName: "",
      showFillModule: false,
      inquiryList: [],
      confirmedDisease: [], //已确诊疾病
      drugDiseaseList: [], //药品疾病列表
      current: 0, //就诊人步骤条
      checkSex: 2,
      showRefuse: false,
      DealDesc: "", //拒绝原因
      historyDiseaseCheck: 0,
      allergiesCheck: 0,
      familyHistoryCheck: 0,
      pregnancyAndLactation: 0,
      liverFunctionCheck: 0,
      renalFunctionCheck: 0,
      agreeAgreement: false, //同意问诊协议
      tabIndex: 0,
      oneCompanyName: "",
      tabList: [
        {
          title: "医生列表",
          status: 0,
        },
        // {
        //   title: "问诊已完成记录",
        //   status: 1
        // },
        {
          title: "问诊记录",
          status: 4,
        },
        {
          title: "历史处方",
          status: 2,
        },
      ],
      docList: [],
      doctorStatus: [
        {
          title: "全部",
          sel: true,
        },
        {
          title: "在线",
          sel: false,
        },
        {
          title: "离线",
          sel: false,
        },
      ],
      doctorClass: [
        {
          code: "",
          title: "全部",
          sel: true,
        },
        {
          code: "101",
          title: "预防保健科",
          sel: false,
        },
        {
          code: "102",
          title: "全科医疗科",
          sel: false,
        },
        {
          code: "103",
          title: "内科",
          sel: false,
        },
        {
          code: "104",
          title: "外科",
          sel: false,
        },
        {
          code: "105",
          title: "妇产科",
          sel: false,
        },
        {
          code: "106",
          title: "妇女保健科",
          sel: false,
        },
        {
          code: "107",
          title: "儿科",
          sel: false,
        },
        {
          code: "108",
          title: "小儿外科",
          sel: false,
        },
        {
          code: "109",
          title: "儿童保健科",
          sel: false,
        },
        {
          code: "110",
          title: "眼科",
          sel: false,
        },
        {
          code: "111",
          title: "耳鼻咽喉科",
          sel: false,
        },
        {
          code: "112",
          title: "口腔科",
          sel: false,
        },
        {
          code: "113",
          title: "皮肤科",
          sel: false,
        },
        {
          code: "114",
          title: "医疗美容科",
          sel: false,
        },
        {
          code: "115",
          title: "精神科",
          sel: false,
        },
        {
          code: "116",
          title: "传染科",
          sel: false,
        },
        {
          code: "117",
          title: "结核病科",
          sel: false,
        },
        {
          code: "118",
          title: "地方病科",
          sel: false,
        },
        {
          code: "119",
          title: "肿瘤科",
          sel: false,
        },
        {
          code: "150",
          title: "中医科",
          sel: false,
        },
      ],
      doctorClassCode: "",
      PageTotalD: 0,
      doctorClassification: [
        {
          title: "全部",
          sel: true,
        },
        {
          title: "推荐医生",
          sel: false,
        },
      ],
      isdbHandle: false,
    };
  },
  methods: {
    //查看详细的信息
    getEncodeData() {
      if (!this.isShowEnCode) {
        let data = {
          inquiryId: this.consultationDetails.InquiryId,
        };
        GetInquiryEncodeData(data).then((res) => {
          if (res.code == 1) {
            this.mingCode = res.data;
            this.isShowEnCode = !this.isShowEnCode;
          } else {
            this.$Message.error(res.msg);
          }
        });
      } else {
        this.mingCode = [];
        this.isShowEnCode = !this.isShowEnCode;
      }
    },
    getShopPac() {
      let data = {
        ShopId: getCookie("ShopId"),
      };
      GetShopPackage(data).then((res) => {
        if (res.code == 1) {
          if (res.data.length == 0) {
            this.showSpace = false;
          } else {
            this.showSpace = true;
          }
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    //指定药品处方免费
    handelAppoint() {
      this.appintShow = !this.appintShow;
      console.log(123);
    },
    //在线问诊检测是否有套餐 1==在线问诊 2==快速问诊 其他情况是续方
    checkifPackage(type) {
      if (this.isdbHandle) return;
      this.isdbHandle = true;
      GetPackage()
        .then((res) => {
          this.isdbHandle = false;
          if (res.code == 1) {
            // if (res.data.SubmitType == 1) {
            //根据登录账号确定是否显示提单的入口
            let companyName = localStorage.getItem("companyName")
              ? localStorage.getItem("companyName")
              : "";
            if (companyName.indexOf("丘权测试店") != -1) {
              //允许在pc补方
              if (!res.data.ShopPackage) {
                this.$Modal.info({
                  title: "在线问诊",
                  content:
                    "当前店铺无剩余图文问诊次数，无法进行问诊操作，请到【莲藕健康APP】购买",
                });
              } else {
                if (type == 1) {
                  this.showTip1 = true;
                } else if (type == 2) {
                  this.rapidInterrogation();
                } else {
                  this.clickKeep(type);
                }
              }
              return;
            } else {
              //只能通过扫描二维码提交处方
              GetInquiryWxOpenQrCode_Base64().then((res) => {
                if (res.code == 1) {
                  this.openQiCode = "data:image/png;base64," + res.data;
                  this.showWxSubMit = !this.showWxSubMit;
                } else {
                  this.$Message.error(res.msg);
                }
              });
            }
          } else {
            this.$Message.error(res.msg);
          }
        })
        .catch((err) => {
          this.isdbHandle = false;
        });
    },
    //回选的时候初始华疾病史
    checkGridorMan(sex) {
      if (this.details.NurseType != 2) {
        this.details.NurseType = 0;
      }
    },
    //当前店铺是总部，获取门店列表
    GetAllList() {
      var parans = {
        pageIndex: 1,
        pageSize: 2000,
      };
      GetChildShopList(parans).then((res) => {
        if (res.code == 1) {
          this.childStoreList = res.data.list;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    //快速问诊按钮
    rapidInterrogation() {
      this.showFillModule = true;
      this.ininUpLoaderUrl();
      this.showTip1 = false;
      this.details = cloneObj(this.originData);
      this.confirmedDisease = [];
      this.drugDiseaseList = [];
      this.agreeAgreement = false;
      this.details.PicList = [];
      this.current = 0;
    },
    gotoChatOrHis() {
      if (this.chatStatus == 0) {
        window
          .genTestUserSig()
          .then((res) => {
            this.tim
              .login({
                userID: localStorage.getItem("app_mobile"),
                userSig: res.userSig,
              })
              .then((a) => {
                this.loading = false;
                this.$store.commit("toggleIsLogin", true);
                this.$store.commit("startComputeCurrent");
                this.$store.commit("showMessage", {
                  type: "success",
                  message: "连接成功",
                });
                this.$store.commit("changeChat");
                this.selectGroup(
                  this.groupID,
                  this.consultationDetails.InquiryId
                );
                // this.applyJoinGroup(item.GroupId);
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((error) => {
            this.loading = false;
            this.$store.commit("showMessage", {
              message: "连接失败：" + error.message,
              type: "error",
            });
          });
      } else if (this.chatStatus == 2) {
        this.$store.commit("changeHisChat", true); //显示历史聊天框
      }
    },
    // 根据身份证号自动填写出生年月
    getCarId(i) {
      this.details.carId = this.details.carId.replace(/[\W]/g, "");
      if (this.details.carId.length >= 16) {
        //获取性别
        this.disableSex = true;
        if (parseInt(this.details.carId.substr(16, 1)) % 2 == 1) {
          // 0==男 1==女
          //男
          this.details.sex = 0;
          this.checkGridorMan();
        } else {
          //女
          this.details.sex = 1;
        }
      } else {
        this.details.sex = 2;
        this.disableSex = false;
      }
      // let
      if (this.details.carId.length >= 14) {
        if (!isNaN(this.details.carId.substr(6, 6))) {
          // let nowYear = new Date().getFullYear();
          // let nowMonth = new Date().getMonth + 1;
          // let year = this.details.carId.substr(6, 4);
          // let month = this.details.carId.substr(10, 2);
          // let allDay = this.getDaysOfEveryMonth(year, month);
          // let day = this.details.carId.substr(12, 2);
          // if (isNaN(year) || year < 1900 || year > nowYear) {
          //   return;
          // }

          // if (isNaN(month) || month < 1 || month > nowMonth || month > 12) {
          //   return;
          // }
          // if (isNaN(day) || day < 1 || day > allDay.length) {
          //   return;
          // }
          //根据身份证的号码判断生日和年龄
          var birthDay = `${this.details.carId.substr(
            6,
            4
          )}-${this.details.carId.substr(10, 2)}-${this.details.carId.substr(
            12,
            2
          )}`;
          //引入年龄的函数
          var age = getAge(birthDay);
          //16岁 加上切割
          if (age.indexOf("岁") != -1) {
            //找到有岁字，说明年龄是不是今年的时候出生
            //获取到年龄的切割字符串，number化
            var borthDayNumber = Number(age.substr(0, age.length - 1));
            //判断当前的年龄是否是小于14岁
            if (borthDayNumber >= 14) {
              //给隐藏的字段赋值
              this.isShowWeight = false;
            } else {
              //给隐藏的字段赋值
              this.isShowWeight = true;
            }
          } else if (age.indexOf("月") != -1) {
            this.isShowWeight = true;
          } else {
            //给隐藏的字段赋值
            this.isShowWeight = false;
          }

          this.currentDate = new Date(
            `${this.details.carId.substr(6, 4)}-${this.details.carId.substr(
              10,
              2
            )}`
          );
          this.details.birthday = `${this.details.carId.substr(
            6,
            4
          )}-${this.details.carId.substr(10, 2)}-${this.details.carId.substr(
            12,
            2
          )}`;
        }
      } else {
        this.isShowWeight = false;
      }
    },
    //根据身份证号码获取出生年月
    getBirthdayFromIdCard(idCard) {
      var birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 15) {
          birthday = "19" + idCard.substr(6, 6);
        } else if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }

      return birthday;
    },
    //判断是否是润年
    getDaysOfEveryMonth(year, month) {
      var baseMonthsDay = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; //各月天数
      var thisYear = year;
      var thisMonth = month;
      var thisMonthDays = []; //这个月有多少天
      //判断是闰年吗？闰年2月29天
      function isRunYear(fullYear) {
        return (
          fullYear % 4 == 0 && (fullYear % 100 != 0 || fullYear % 400 == 0)
        );
      }

      function getThisMonthDays(days) {
        //传天数，返天数数组
        var arr = [];
        for (var i = 1; i <= days; i++) {
          arr.push(i);
        }
        return arr;
      }

      if (isRunYear(thisYear) && thisMonth == "02") {
        //闰年2月29天
        thisMonthDays = getThisMonthDays(baseMonthsDay[thisMonth] + 1);
      } else {
        if (thisMonth.indexOf("0") == -1) {
          var index = thisMonth;
        } else {
          var index = thisMonth.substr(1, 1);
        }
        thisMonthDays = getThisMonthDays(baseMonthsDay[index - 1]);
      }
      return thisMonthDays;
    },
    //限制只能选择三个
    limetThree(events) {
      if (this.confirmedDisease.length > 3) {
        this.$Modal.warning({
          title: "线下已确诊疾病,最多只能选择三个！",
          onOk: () => {
            events.pop();
            this.confirmedDisease = events;
          },
        });
      }
    },
    //修改详情
    changeDetail(data) {
      this.ininUpLoaderUrl();
      this.confirmedDisease = [];
      this.drugDiseaseList = [];
      this.showFillModule = true;
      this.showInquiryDetail = false;
      this.current = 0;
      this.details.name = data.Name;
      this.details.mobile = data.PhoneNo;
      this.details.sex = data.Sex == 1 ? 0 : 1;
      this.details.carId = data.IDCard;
      this.details.birthday = data.Birthdate + "-01";
      this.details.AMHType = data.AMHType;
      this.details.AMHDesc = data.AMHDesc;
      this.details.FMHType = data.FMHType;
      this.details.FMHDesc = data.FMHDesc;
      this.details.LiverType = data.LiverType;
      this.details.LiverDesc = data.LiverDesc;
      this.details.NurseType =
        data.NurseDesc == "无"
          ? 0
          : data.NurseDesc == "备孕中"
          ? 2
          : data.NurseDesc == "怀孕中"
          ? 3
          : 4;
      // this.details.NurseType = data.NurseType;
      this.details.NurseDesc = data.NurseDesc;
      this.details.weight = data.Weight;
      this.details.PMHType = data.PMHType;
      this.details.PMHDesc = data.PMHDesc;
      this.details.RenalType = data.RenalType;
      this.details.RenalDesc = data.RenalDesc;
      this.details.DiseaseList = data.DiseaseList; //DiseaseId症状ID 线下已就诊疾病
      data.DiseaseList.map((arry, i) => {
        this.confirmedDisease.push(arry.Name);
        var obj = {
          DiseaseName: arry.Name,
          ICDCode: arry.ICDCode,
        };
        this.drugDiseaseList.push(obj);
      });
      data.DrugsList.map((res, index) => {
        data.DrugsList[index].IsMainSel = res.IsMain == 1 ? true : false;
      });
      this.details.DrugsList = data.DrugsList;
      this.details.PicList = data.PicList;
      this.InquiryId = data.InquiryId;

      this.updata = true;

      this.updata = false;
    },
    //图片路径换取code
    // getImgCode(inquiryId) {
    //   var params = {
    //     inquiryId
    //   };
    //   return GetInquiryPicCode(params).then(res => {
    //     res.data.list;
    //   });
    // },
    // 填写完信息后，点击问诊详情
    gotoInquiryDetail() {
      this.showFillModule = false;
      // this.clickInquiryDetail();
      this.tabIndex = 4;
      this.page = 1;
      // this.getInquiryList();
    },
    // 保存处方
    downloads() {
      const image = new Image();
      // 解决跨域 canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        //得到图片的base64编码数据
        const url = canvas.toDataURL("image/png");
        // 生成一个 a 标签
        const a = document.createElement("a");
        // 创建一个点击事件
        const event = new MouseEvent("click");
        // 将 a 的 download 属性设置为我们想要下载的图片的名称，若 name 不存在则使用'图片'作为默认名称
        a.download = name || "莲藕互联网医院处方笺";
        // 将生成的 URL 设置为 a.href 属性
        a.href = url;
        // 触发 a 的点击事件
        a.dispatchEvent(event);
        // return a;
      };
      image.src = this.OrderFileUrl;
    },
    //线下已确诊疾病添加
    addchange() {
      this.searchDis();
      this.showDisModule = true;
    },
    // 打印处方
    printInquiryImg() {
      this.$print(this.$refs.print); // 使用
    },

    // 改变店铺
    changeShop(name) {
      if (this.shopName == name) return;
      const msg = this.$Message.loading({
        content: "切换店铺中",
        duration: 0,
      });
      let arr = this.shopList.filter((item) => item.ShopName == name);
      let data = {
        shopId: arr[0].ShopId,
      };

      EditSwichEnterprise(data)
        .then((res) => {
          localStorage.setItem("companyName", arr[0].ShopName);
          localStorage.setItem("extendType", arr[0].ShopType);
          localStorage.setItem("ShopId", arr[0].ShopId);
          setCookie("ShopId", arr[0].ShopId, "h12");
          this.shopName = arr[0].ShopName;
          this.shopType = arr[0].ShopType;
          sessionStorage.setItem("status", 0);
          window.location.reload();
          setTimeout(msg, 17);
        })
        .catch((err) => {
          setTimeout(msg, 17);
        });
    },
    // showFillModule(){
    //   this.showFillModule = true;
    //  this.uploadData = {
    //     Token: localStorage.getItem("hToken"),
    //     AppKey: this.$store.state.AppKey
    //   }
    // },
    // 搜索疾病
    searchDis() {
      if (!this.searchDisValue) {
        return;
      }
      const msg = this.$Message.loading({
        content: "搜索中",
        duration: 0,
      });
      GetDiseaseList({
        diseaseName: this.searchDisValue,
      }).then((res) => {
        setTimeout(msg, 17);
        if (res.code == 1) {
          if (res.data.list) {
            res.data.list.map((item) => {
              item.sel = false;
              item.Name = item.DiseaseName;
            });
            this.drugDiseaseList.map((item) => {
              res.data.list.map((items) => {
                if (item.DiseaseName == items.Name) {
                  items.sel = true;
                }
              });
            });
            this.searchDiseaseList = res.data.list.slice(0, 10);
          }
        }
      });
    },
    // 添加疾病
    addDis(item, i) {
      var obj = {
        DiseaseName: item.Name,
        ICDCode: item.ICDCode,
      };
      if (this.confirmedDisease.length < 3) {
        this.confirmedDisease.push(item.Name); //已确诊疾病
      }

      this.searchDiseaseList[i].sel = true;
      this.drugDiseaseList.push(obj); //药品疾病列表
    },
    //
    deleteDis(item, i) {
      var _that = this;
      this.searchDiseaseList[i].sel = false;

      var selDataDrug = [];
      for (var i = 0; i < this.drugDiseaseList.length; i++) {
        if (this.drugDiseaseList[i].DiseaseName != item.Name) {
          selDataDrug.push(this.drugDiseaseList[i]);
        }
      }

      this.drugDiseaseList = selDataDrug;

      var selData = [];
      _that.confirmedDisease.map((items, index) => {
        if (items != item.Name) {
          selData.push(items);
        }
      });
      setTimeout((res) => {
        _that.confirmedDisease = selData;
      });
    },
    // // 问诊列表条件筛选
    // filterSearchInquiry() {
    //   // return
    //   this.page = 1;
    //   const msg = this.$Message.loading({
    //     content: "搜索中",
    //     duration: 0
    //   });
    //   this.getInquiryList(msg);
    // },
    // 点击退出
    submitExit() {
      localStorage.clear();
      sessionStorage.clear();
      delCookie("access_token");
      clearAllCookie();
      this.$router.replace({ path: "/login" });
    },
    // 删除处方图片
    deleteUploadImg(i) {
      this.details.PicList.splice(i, 1);
    },
    //上传图片之前的回调
    uploadBefore() {
      this.uploadBeforemsg = this.$Message.loading({
        content: "图片上传中",
        duration: 0,
      });
    },
    // 上传图片成功回调
    uploadSuccess(e) {
      if (this.uploadBeforemsg) {
        setTimeout(this.uploadBeforemsg, 17);
      }
      if (!this.details.PicList) {
        this.details.PicList = [];
      }
      if (this.details.PicList.length >= 5) {
        this.$Message.error("最多上传5张病历");
        return;
      }
      this.details.PicList.push({
        Url: e.data.ImgUrl,
        code: e.data.Code,
      });
    },
    // 选择主要用药
    isMainChange(item, index) {
      this.details.DrugsList.map((items) => {
        items.IsMainSel = false;
        items.IsMain = 0;
      });
      this.details.DrugsList[index].IsMainSel = true;
      this.details.DrugsList[index].IsMain = 1;
      // this.searchDisValue = item.ComName;
      // this.searchDis();
      // this.details.DrugsList[index].DiseaseList.map(item => {
      //   this.drugDiseaseList.push(item.Name);
      // });
      this.GetByComNames(item.ComName, index);
      this.$forceUpdate();
    },
    //根据药品获取常用疾病
    GetByComNames(conName, index) {
      const msg = this.$Message.loading({
        content: "选择中",
        duration: 0,
      });
      var params = {
        commonName: conName,
        sex: this.details.sex == 0 ? 1 : 2, //性别 1=男；2=女；,
        birthday: this.details.birthday,
      };
      GetDiagnoseByComNames(params).then((res) => {
        if (res.code == 1) {
          setTimeout(msg, 17);
          this.drugDiseaseList = [];
          this.confirmedDisease = [];
          this.details.DrugsList[index].DiseaseList = res.data.list;
          this.details.DrugsList[index].DiseaseList.map((item) => {
            var obj = {
              DiseaseName: item.DiseaseName,
              ICDCode: item.ICDCode,
            };
            this.drugDiseaseList.push(obj);
          });
        }
      });
    },
    //删除主用药
    dele(item, index) {
      this.showdelete = true;
      this.deleteIndex = index;
      this.deleteItem = item;
    },
    configDele(index) {
      let curryItem = this.details.DrugsList[this.deleteIndex];
      this.searchDrugList.map((items) => {
        if (curryItem.DrugId == items.DrugId) {
          items.sel = false;
          return false;
        }
      });
      this.details.DrugsList.splice(index, 1);
    },
    // 添加药品
    addSearchDrug(item, i) {
      if (this.details.DrugsList.length >= 5) {
        this.$Message.error("最大开方药品为5");
        return;
      }
      this.searchDrugList[i].sel = true;
      item.Count = 1;
      item.IsMain = 0;
      item.IsMainSel = false;
      this.details.DrugsList.push(item);
    },
    // 取消药品
    cannelAddDrug(item, i) {
      this.searchDrugList[i].sel = false;
      this.details.DrugsList.splice(
        this.details.DrugsList.indexOf(item.DrugId),
        1
      );
    },
    //添加既往用药
    addPast() {
      this.showSeachMobule = true;
      this.submitSearch();
    },
    // 搜索药品
    submitSearch(er) {
      if (!this.searchDrugValue) return;
      if (er == 0) {
        this.drugPage = 1;
      }
      let Token = localStorage.getItem("hToken");
      let data = {
        commonName: this.searchDrugValue,
        pageIndex: this.drugPage,
        pageSize: 5,
      };
      const msg = this.$Message.loading({
        content: "搜索中",
        duration: 0,
      });
      GetDrugsList(data).then((res) => {
        setTimeout(msg, 17);
        if (res.code == 1) {
          this.details.DrugsList.map((item) => {
            res.data.list.map((items) => {
              if (item.DrugId == items.DrugId) items.sel = true;
            });
          });
          res.data.list.map((item) => {
            if (!item.sel) item.sel = false;
          });
          this.drugTotal = res.data.total;

          this.searchDrugList = res.data.list;
        }
      });
    },
    // 药品搜索分页
    searchDrugPageChange(i) {
      this.drugPage = i;
      this.submitSearch();
    },
    // 点击问诊记录分页
    // pageChange(i) {
    //   this.page = i;
    //   this.getInquiryList();
    // },
    // 点击拒绝原因
    clickRefuseResult(item) {
      if (item.DealDesc) {
        this.showRefuse = true;
        this.DealDesc = item.DealDesc;
      }
    },
    // 点击续方
    clickKeep(item) {
      //初始化图片上传
      this.ininUpLoaderUrl();
      let that_t = this;
      const msg = this.$Message.loading({
        content: "请稍候",
        duration: 0,
      });
      //获取续方详情
      GetInquiry({
        InquiryId: item.InquiryId,
      })
        .then((res) => {
          if (res.code == 1) {
            res.InquiryInfo = res.data.Inq;
            res.InquiryInfo.DrugsList = res.data.Drugs;
            res.InquiryInfo.DiseaseList = res.data.Dis;
            let data = res.InquiryInfo;
            // res.data.Inq.PicUrls= "https://test-pic.lian-ou.com/HMP/APP/Inquiry/20200313/e0ed87d4d63d46f5b722e6106e0aeed1.jpg;"
            if (res.data && !res.data.Inq.PicUrls) {
              setTimeout(msg, 17);
              this.assignment(data);
            } else {
              //请求图片code
              GetInquiryPicCode({
                InquiryId: item.InquiryId,
              })
                .then((resImg) => {
                  setTimeout(msg, 17);
                  this.assignment(data);
                  resImg.data.list.map((itemimg) => {
                    this.details.PicList.push({
                      Url: itemimg.ImgUrl,
                      code: itemimg.Code,
                    });
                  });
                })
                .catch((err) => {
                  setTimeout(msg, 17);
                });
            }
          } else {
            setTimeout(msg, 17);
            this.$Message.error(res.msg);
          }
        })
        .catch((err) => {
          setTimeout(msg, 17);
        });
    },
    //赋值
    assignment(data) {
      let that_t = this;
      data.DrugsList.map((item) => {
        if (item.IsMain == 1) {
          item.IsMainSel = true;
          this.drugDiseaseList = [];
          console.log(item.DiseaseList);
          // item.DiseaseList.map(item => {

          //   this.drugDiseaseList.push(item.Name);
          // });
        } else {
          item.IsMainSel = false;
        }
      });
      if (this.drugDiseaseList.length == 0) {
        data.DiseaseList.map((item) => {
          var obj = {
            DiseaseName: item.DiseaseName,
            ICDCode: item.ICDCode,
          };
          that_t.drugDiseaseList.push(obj);
        });
      }
      this.current = 0;
      this.showFillModule = true;
      this.details = cloneObj(this.originData);
      // data.PicList = [];
      // data.PicList.map(item => {
      //   this.details.PicList.push({
      //     Url: item.Url
      //   });
      // });
      this.details.name = data.Name;
      this.details.mobile = data.Mobilephone;
      this.details.sex = data.Sex == 1 ? 0 : 1;
      this.details.carId = data.IDCard;
      this.details.birthday = data.Birthday.split("T")[0];
      this.details.AMHType = data.AMHType;
      this.details.AMHDesc = data.AMHDesc;
      this.details.FMHType = data.FMHType;
      this.details.FMHDesc = data.FMHDesc;
      this.details.LiverType = data.LiverType;
      this.details.LiverDesc = data.LiverDesc;
      this.details.NurseType = data.NurseType;
      this.details.NurseDesc = data.NurseDesc;
      this.details.weight = data.Weight;
      this.details.PMHType = data.PMHType;
      this.details.PMHDesc = data.PMHDesc;
      this.details.RenalType = data.RenalType;
      this.details.RenalDesc = data.RenalDesc;
      this.confirmedDisease = [];
      this.details.DrugsList = [];
      data.DiseaseList.map((item) => {
        that_t.confirmedDisease.push(item.DiseaseName);
      });
      data.DrugsList.map((item) => {
        that_t.details.DrugsList.push(item);
      });
      this.getCarId();
      this.$forceUpdate();
    },
    //一键签名
    oneKeySignature(e) {
      //e==3 签3个名字 e==2签2个名字
      console.log(e);
      this.signaNum = e;
      this.lookShop = !this.lookShop;
      this.oneShop = !this.oneShop;
    },
    closeoneModule() {
      this.oneShop = !this.oneShop;
      this.lookShop = !this.lookShop;
    },
    //关闭查看处方弹框
    closeModule() {
      this.lookShop = !this.lookShop;
    },
    // 点击查看处方
    clickSeePrescription(item) {
      this.rowInquiryId = item.LoInquiryId;
      this.lookShop = !this.lookShop;
    },

    // 点击问诊详情
    clickInquiryDetail(item) {
      this.isShowEnCode = false;
      this.$store.commit("changeInquiryStatus", item.inqStatus);
      this.oneCompanyName = item.CompanyName;
      const msg = this.$Message.loading({
        content: "请稍候",
        duration: 0,
      });
      GetInquiry({
        InquiryId: item.InquiryId,
      })
        .then((res) => {
          console.log(JSON.stringify(res.data));
          if (res.code == 1) {
            if (res.data && !res.data.Inq.PicUrls) {
              setTimeout(msg, 17);
              res.InquiryInfo = res.data.Inq;
              res.InquiryInfo.DiseaseList = res.data.Dis;
              res.InquiryInfo.DrugsList = res.data.Drugs;
              res.InquiryInfo.DiseaseList.map((item) => {
                item.Name = item.DiseaseName;
              });
              res.InquiryInfo.PhoneNo = res.data.Inq.Mobilephone;
              res.InquiryInfo.Birthdate = res.data.Inq.Birthday;
              res.InquiryInfo.PicList = [];
              this.consultationDetails = res.InquiryInfo;
              this.hisInquiryId = res.InquiryInfo.InquiryId;
              // this.groupID = item.GroupId;

              // if (
              //   (item.GroupId && item.inqStatus == 3) ||
              //   (item.GroupId && item.inqStatus == 9) ||
              //   (item.GroupId && item.inqStatus == 1)
              // ) {
              //   this.chatStatus = 1;
              // } else if (item.GroupId) {
              //   this.chatStatus = 2;
              // } else {
              //   this.chatStatus = 3;
              // }
              this.showInquiryDetail = true;
              return false;
            }
            var params = {
              inquiryId: res.data.Inq.InquiryId,
            };
            GetInquiryPicCode(params)
              .then((resImg) => {
                setTimeout(msg, 17);
                res.InquiryInfo = res.data.Inq;
                res.InquiryInfo.DiseaseList = res.data.Dis;
                res.InquiryInfo.DrugsList = res.data.Drugs;
                res.InquiryInfo.DiseaseList.map((item) => {
                  item.Name = item.DiseaseName;
                });
                // res.InquiryInfo.DiseaseList[
                //   res.InquiryInfo.DiseaseList.length - 1
                // ].Name = res.InquiryInfo.DiseaseList[
                //   res.InquiryInfo.DiseaseList.length - 1
                // ].Name.substring(
                //   0,
                //   res.InquiryInfo.DiseaseList[
                //     res.InquiryInfo.DiseaseList.length - 1
                //   ].Name.length - 1
                // );
                res.InquiryInfo.PhoneNo = res.data.Inq.Mobilephone;
                res.InquiryInfo.Birthdate = res.data.Inq.Birthday;
                res.InquiryInfo.PicList = [];
                resImg.data.list.map((itemimg) => {
                  res.InquiryInfo.PicList.push({
                    Url: itemimg.ImgUrl,
                    code: itemimg.Code,
                  });
                });
                this.consultationDetails = res.InquiryInfo;
                this.hisInquiryId = res.InquiryInfo.InquiryId;

                // this.groupID = item.GroupId;

                // if (
                //   (item.GroupId && item.inqStatus == 3) ||
                //   (item.GroupId && item.inqStatus == 9) ||
                //   (item.GroupId && item.inqStatus == 1)
                // ) {
                //   this.chatStatus = 1;
                // } else if (item.GroupId) {
                //   this.chatStatus = 2;
                // } else {
                //   this.chatStatus = 3;
                // }
                this.showInquiryDetail = true;
              })
              .catch((err) => {
                setTimeout(msg, 17);
              });
          }
        })
        .catch((err) => {
          setTimeout(msg, 17);
        });
    },
    // 查询是否可以修改
    checkStatus() {
      let Token = localStorage.getItem("hToken");
      const msg = this.$Message.loading({
        content: "请稍候",
        duration: 0,
      });
      GetInquiry({
        AppKey: this.$store.state.AppKey,
        Token,
        InquiryId: this.consultationDetails.InquiryId,
      }).then((res) => {
        setTimeout(msg, 17);
        if (res.errcode == 0) {
          res.InquiryInfo.DiseaseList.map((item) => {
            item.Name = item.Name + "，";
          });
          res.InquiryInfo.DiseaseList[
            res.InquiryInfo.DiseaseList.length - 1
          ].Name = res.InquiryInfo.DiseaseList[
            res.InquiryInfo.DiseaseList.length - 1
          ].Name.substring(
            0,
            res.InquiryInfo.DiseaseList[res.InquiryInfo.DiseaseList.length - 1]
              .Name.length - 1
          );
          this.consultationDetails = res.InquiryInfo;
          if (res.InquiryInfo.Status != 3 && res.InquiryInfo.Status != 1) {
            // this.$store.dispatch('logout')
            // this.$store.commit("changeChat")
            this.$store.commit("changeHisChat", false);
            this.changeDetail(this.consultationDetails);
          } else {
            alert("药品信息已不能修改");
          }
        } else {
          Toast();
        }
      });
    },
    //初始化上传图片路径
    ininUpLoaderUrl() {
      //秒级时间戳
      var secondObj = {
        nonce: Math.random().toString(),
        timestamp: parseInt(new Date().getTime() / 1000),
        update: true,
        useType: 7,
      };
      //排序，按参数的key排序（ascii码升序）
      var sorted = Object.keys(secondObj)
        .sort()
        .map((k) => {
          return k + "=" + secondObj[k];
        })
        .join("&");
      //加密
      var sign = SHA1(sorted).toUpperCase();
      this.UploadUrl =
        process.env.VUE_APP_APPV3 + `Shop/UploadShopPic?${sorted}&sign=${sign}`;
      this.uploadData = {};
    },
    // 关闭就诊人信息填写
    changeFillStatus(value) {
      if (value == "new") {
        this.ininUpLoaderUrl();
        this.showTip1 = false;
        this.details = cloneObj(this.originData);
        this.confirmedDisease = [];
        this.drugDiseaseList = [];
        this.agreeAgreement = false;
        this.details.PicList = [];
        this.current = 0;
      }
      this.updata = false; //修改走oupedate的接口
      this.details = cloneObj(this.originData);
      this.$forceUpdate();
      this.showFillModule = !this.showFillModule;
    },
    selectGroup(groupID, inquiryId) {
      // let that = this
      // this.tim.on(this.TIM.EVENT.SDK_READY, function(res){
      // that.tim.on(that.TIM.EVENT.GROUP_LIST_UPDATED, function(res){
      // if(res.name=="onGroupListUpdated"){
      let data = {
        inquiryId,
        token: localStorage.getItem("hToken"),
        method: 4,
      };
      GetPrescriptionInfo(data).then((res) => {
        if (res == "Again") {
          this.selectGroup(groupID, inquiryId);
        } else if (res.code == 1) {
          if (res.data.Status == 1) {
            this.$store.commit("changeEndMask", false);
          } else if (res.data.Status == 0) {
            this.$store.commit("changeEndMask", true);
          }
          setTimeout(() => {
            this.$store.dispatch("checkoutConversation", `GROUP${groupID}`);
          }, 1200);
        } else {
          Toast(res.msg);
        }
        // if()
      });
    },

    // 申请加入群聊
    applyJoinGroup(groupID) {
      let options = {
        groupID,
        applyMessage: "",
        // type: TIM.TYPES.GRP_PUBLIC
      };
      this.tim
        .joinGroup(options)
        .then((res) => {
          if (res.data.status == "AlreadyInGroup") {
            this.tim.on(
              this.TIM.EVENT.SDK_READY,
              function (res) {
                this.$store.dispatch("checkoutConversation", `GROUP${groupID}`);
              },
              this
            );
          }
        })
        .catch(function (imError) {
          console.warn("joinGroup error:", imError); // 申请加群失败的相关信息
        });
      // setTimeout(() => {
      //   this.$store.dispatch("checkoutConversation", "GROUP"+groupID);
      // }, 1000);
    },
    //提交问诊按钮pankailiang
    submitInquiry() {
      let a = this.details;
      let filter1 = a.DrugsList.filter((item) => {
        return item.IsMain == 1;
      });
      if (a.DrugsList.length == 0) {
        this.$Message.error("请添加既往用药");
        return;
      } else if (filter1.length == 0) {
        this.$Message.error("请选择主要用药");
        return;
      } else if (this.confirmedDisease.length == 0) {
        this.$Message.error("请至少选择一个线下已确诊疾病");
        return;
      } else if (!this.questioningMethod) {
        this.$Message.error("请选择问诊方式");
        return;
      } else if (!this.agreeAgreement) {
        this.$Message.error(
          "请同意并阅读《知情同意书》与《莲藕互联网医院服务协议》"
        );
        return;
      }

      if (this.submitInquiryIng) return;
      this.submitInquiryIng = true;
      const msg = this.$Message.loading({
        content: "提交问诊中，请稍候",
        duration: 0,
      });
      let DiseaseList = [];
      this.confirmedDisease.map((item) => {
        this.drugDiseaseList.map((items) => {
          if (items.DiseaseName == item) {
            DiseaseList.push(items);
          }
        });
      });
      let DrugsList = [];
      this.details.DrugsList.map((item) => {
        var obj = {
          DrugId: item.DrugId,
          DrugName: item.DrugName,
          ComName: item.ComName || item.CommonName,
          Specs: item.Specs,
          FactoryName: item.FactoryName,
          ApprovalNo: item.ApprovalNo || "",
          UpcCode: item.UpcCode,
          IsMain: item.IsMain,
          Unit: item.Unit,
          Count: item.Count,
          IsMainSel: item.IsMainSel,
        };

        DrugsList.push(obj);
      });
      let PicList = [];
      this.details.PicList.map((item) => {
        PicList.push({
          PicCode: item.code,
        });
      });

      //保存用药人信息，身份证是唯一或者openId是唯一
      var potionalInfo = {
        PatientId: "",
        Mobilephone: this.details.mobile,
        Source: 5, // 提交人类型：1=app二维码；3=app提交；5=pc药店端；7=公众号；
        OpenId: getCookie("OpenId"),
        ShopId: getCookie("ShopId"),
        UserId: getCookie("UserId"),
        Name: this.details.name,
        Birthday: this.details.birthday,
        IDCard: this.details.carId,
        IdCardImg: "",
        Sex: this.details.sex == 0 ? 1 : 2,
        PMHType: this.details.PMHType, //过往病史 0=无；1=有；,
        PMHDesc: this.details.PMHDesc,
        AMHType: this.details.AMHType, //过敏史0=无；1=有；,
        AMHDesc: this.details.AMHDesc,
        FMHType: this.details.FMHType, //家族病史,
        FMHDesc: this.details.FMHDesc,
        LiverType: this.details.LiverType, //肝功能异常0=无；1=有；,
        LiverDesc: this.details.LiverDesc,
        RenalType: this.details.RenalType, //肾功能异常0=无；1=有；,
        RenalDesc: this.details.RenalDesc,
        NurseType: this.details.NurseType == 0 ? 0 : 1, //是否妊娠哺乳0=无；1=有；,
        NurseDesc:
          this.details.NurseType == 0
            ? ""
            : this.details.NurseType == 2
            ? "备孕中"
            : this.details.NurseType == 3
            ? "怀孕中"
            : "正在哺乳",
        Weight: this.details.weight,
      };
      // if (this.details.sex == 0) {
      //   //当sex为男时，妊娠重置为无
      //   potionalInfo.NurseType = 0;
      //   potionalInfo.NurseDesc = "无";
      // }
      SavePatient(potionalInfo).then((res) => {
        if (res.code == 1) {
          var PatientId = res.data; //用药人信息id
          var savePamas = {
            UserId: getCookie("UserId"),
            OpenId: getCookie("OpenId") == "null" ? "" : getCookie("OpenId"),
            ShopId: getCookie("ShopId"),
            PatientId,
            SymptomDesc: "",
            DiseaseList,
            DrugsList,
            PicList: PicList,
            SourceType: 5,
            ModeType: 1,
          };
          SaveInquiry(savePamas)
            .then((ress) => {
              this.submitInquiryIng = false;
              setTimeout(msg, 17);
              if (ress.code == 1) {
                console.log(ress);
                // window.genTestUserSig("").then(response => {
                //   this.tim
                //     .login({
                //       userID: localStorage.getItem("app_mobile"),
                //       userSig: response.userSig
                //     })
                //     .then(a => {
                //       this.loading = false;
                //       // this.$store.commit("toggleIsLogin", true);
                //       // this.$store.commit("startComputeCurrent");
                //       // this.$store.commit("showMessage", {
                //       //   type: "success",
                //       //   message: "连接成功"
                //       // });
                //       // this.$store.commit("changeChat");

                //       // this.selectGroup(res.GroupId, res.InquiryId);
                //     })
                //     .catch(err => {
                //       console.log(err);
                //     });
                // });
                this.current = 2;
                this.InquiryId = res.data;
                this.$Message.success(ress.msg);
                if (this.tabIndex == 4) {
                  this.$bus.$emit("handleInqEvent");
                }
                var count = 3;
                this.details = cloneObj(this.originData);
                this.searchDrugList = [];
                this.drugDiseaseList = [];
                this.confirmedDisease = [];

                var timer = setInterval(() => {
                  count--;
                  console.log(count);
                  if (count == 0) {
                    this.showFillModule = false;
                    this.showFsaveillModule = false;
                    if (this.tabIndex == 4) {
                      this.$bus.$emit("handleInqEvent");
                    }
                    clearInterval(timer);
                  }
                }, 1000);
                this.$forceUpdate();
              } else {
                this.$Message.error(ress.msg);
              }
            })
            .catch((err) => {
              setTimeout(msg, 17);
              this.submitInquiryIng = false;
              this.$Message.error(err.msg);
            });
        } else {
          setTimeout(msg, 17);
          this.submitInquiryIng = false;
          this.$Message.error(res.msg);
        }
      });

      // if (this.updata) {
      //   data.InquiryId = this.InquiryId;
      //   UpdateInquiry(data)
      //     .then(res => {
      //       this.submitInquiryIng = false;
      //       setTimeout(msg, 17);
      //       if (res.errcode == 0) {
      //         window.genTestUserSig("").then(response => {
      //           this.tim
      //             .login({
      //               userID: localStorage.getItem("app_mobile"),
      //               userSig: response.userSig
      //             })
      //             .then(a => {
      //               this.loading = false;
      //               this.$store.commit("toggleIsLogin", true);
      //               this.$store.commit("startComputeCurrent");
      //               this.$store.commit("showMessage", {
      //                 type: "success",
      //                 message: "连接成功"
      //               });
      //               this.$store.commit("changeChat");
      //               this.selectGroup(res.GroupId, res.InquiryId);
      //             })
      //             .catch(err => {
      //               console.log(err);
      //             });
      //         });
      //         this.updata = false;
      //         this.current = 2;
      //         this.InquiryId = res.InquiryId;
      //         this.$Message.success(res.errmsg);
      //         let count = 3;
      //         this.details = cloneObj(this.originData);
      //         this.searchDrugList = [];
      //         this.drugDiseaseList = [];
      //         this.confirmedDisease = [];
      //         this.$forceUpdate();
      //         let timer = setInterval(() => {
      //           count--;
      //           if (count == 0) {
      //             this.showFillModule = false;
      //           }
      //         }, 1000);
      //       } else {
      //         this.$Message.error(res.errmsg);
      //       }
      //     })
      //     .catch(err => {
      //       setTimeout(msg, 17);
      //       this.submitInquiryIng = false;
      //     });
      // } else {
      //   SaveInquiry(data)
      //     .then(res => {
      //       this.submitInquiryIng = false;
      //       setTimeout(msg, 17);
      //       if (res.errcode == 0) {
      //         window.genTestUserSig("").then(response => {
      //           this.tim
      //             .login({
      //               userID: localStorage.getItem("app_mobile"),
      //               userSig: response.userSig
      //             })
      //             .then(a => {
      //               this.loading = false;
      //               // this.$store.commit("toggleIsLogin", true);
      //               // this.$store.commit("startComputeCurrent");
      //               // this.$store.commit("showMessage", {
      //               //   type: "success",
      //               //   message: "连接成功"
      //               // });
      //               // this.$store.commit("changeChat");

      //               // this.selectGroup(res.GroupId, res.InquiryId);
      //             })
      //             .catch(err => {
      //               console.log(err);
      //             });
      //         });
      //         this.current = 2;
      //         this.InquiryId = res.InquiryId;
      //         this.$Message.success(res.errmsg);
      //         let count = 3;
      //         this.details = cloneObj(this.originData);
      //         this.searchDrugList = [];
      //         this.drugDiseaseList = [];
      //         this.confirmedDisease = [];
      //         this.$forceUpdate();
      //         let timer = setInterval(() => {
      //           count--;
      //           if (count == 0) {
      //             this.showFillModule = false;
      //           }
      //         }, 1000);
      //       } else {
      //         this.$Message.error(res.errmsg);
      //       }
      //     })
      //     .catch(err => {
      //       setTimeout(msg, 17);
      //       this.submitInquiryIng = false;
      //     });
      // }
    },
    // 问诊信息第一步点击下一步
    next(i) {
      let a = this.details;
      let date = new Date().getTime();
      if (!a.name) {
        this.$Message.error("请输入姓名");
        return;
      }
      var reg = /^[\u4e00-\u9fa5\.]+$/gi;
      if (!reg.test(a.name)) {
        this.$Message.error("姓名填写不规范，请重新填写");
        return;
      }

      if (!a.carId) {
        this.$Message.error("请输入身份证号");
        return;
      }
      var carNumber = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      // var carNumber = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|31)|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/;
      // if (a.carId && a.carId != "" && a.carId.length != 18) {
      //   this.$Message.error("身份证有误");
      //   return;
      // }
      if (carNumber.test(a.carId) != true) {
        this.$Message.error("身份证输入有误");
        return;
      }
      if (a.sex == 2) {
        this.$Message.error("请选择性别");
        return;
      }
      // if (!a.birthday) {
      //   this.$Message.error("请选择出生年月");
      //   return;
      // }
      // if (new Date(a.birthday).getTime() > date) {
      //   this.$Message.error("出生日期有误");
      //   return;
      // }
      if (!a.mobile) {
        this.$Message.error("请填写手机号码");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(a.mobile)) {
        this.$Message.error("手机号码输入有误");
        return false;
      }
      if (this.isShowWeight) {
        //判断
        if (a.weight == "null" || a.weight.length == 0) {
          this.$Message.error("14岁以下体重必填");
          return;
        }
      } else {
        this.details.weight = "";
      }
      if (a.PMHType == 1) {
        if (!a.PMHDesc) {
          this.$Message.error("请填写过往病史");
          return;
        }
      } else {
        this.details.PMHDesc = "";
      }
      if (a.AMHType == 1) {
        if (!a.AMHDesc) {
          this.$Message.error("请填写过敏史");
          return;
        }
      } else {
        this.details.AMHDesc = "";
      }
      if (a.FMHType == 1) {
        if (!a.FMHDesc) {
          this.$Message.error("请填写家族病史");
          return;
        }
      } else {
        this.details.FMHDesc = "";
      }
      this.current = i + 1;
    },
    // 出生年月改变
    birstdayChange(value) {
      this.details.birthday = value;
    },
    // 点击医生列表、问诊记录
    changeTab(status, i) {
      if (i == 1) {
        this.$store.commit("changeOrderType", "old");
      } else if (i == 2) {
        this.$store.commit("changeOrderType", "new");
      }
      this.tabIndex = status;
      sessionStorage.setItem("status", status);
      // if (this.tabIndex == 1) {
      //   this.page = 1;
      //   this.getInquiryList();
      // }
    },

    // 点击医生状态、科室、医生分类
    selectCondition(data) {
      let type = data.type;
      let index = data.index;
      if (type == 1) {
        this.doctorStatus.map((item) => (item.sel = false));
        this.doctorStatus[index].sel = true;
      } else if (type == 2) {
        this.doctorClass.map((item) => (item.sel = false));
        this.doctorClass[index].sel = true;
        this.choseDotor(data.code);
      } else {
        this.doctorClassification.map((item) => (item.sel = false));
        this.doctorClassification[index].sel = true;
      }
    },
    // 获取医生列表
    getDocList() {
      var pamas = {
        name: "",
        deptCode: this.doctorClassCode,
        pageIndex: this.page,
        pageSize: 9,
      };
      GetDoctorList(pamas).then((res) => {
        this.docList = res.data.list;
        this.PageTotalD = res.data.total;
        console.log(res);
      });
    },
    //点击选择科室
    choseDotor(code) {
      this.doctorClassCode = code;
      this.getDocList();
    },
    //医生列表分页
    pageChangeD(i) {
      this.page = i;
      this.getDocList();
    },
    //提交时间的改变
    createDateChange(value) {
      this.filterCondition.createDate = value;
    },
    // 获取问诊列表
    // getInquiryList(msg) {
    //   let UserId = localStorage.getItem("app_mobile");
    //   let companyName = localStorage.getItem("companyName");
    //   let Token = localStorage.getItem("hToken");
    //   let ShopType = this.shopType;
    //   let ModeType =
    //     this.filterCondition.selectModel == "全部"
    //       ? ""
    //       : this.filterCondition.selectModel == "视频问诊"
    //       ? 5
    //       : 1;
    //   let InquiryStatus =
    //     this.filterCondition.prescriptionStatus == "全部"
    //       ? ""
    //       : this.filterCondition.prescriptionStatus == "等待接诊"
    //       ? 1
    //       : this.filterCondition.prescriptionStatus == "接诊中"
    //       ? 3
    //       : this.filterCondition.prescriptionStatus == "已开方"
    //       ? 5
    //       : 99;
    //   GetInquiryList({
    //     Page: this.page,
    //     ShopType, //登录店铺的类型
    //     PageSize: 10,
    //     AppKey: this.$store.state.AppKey,
    //     Token,
    //     UserId, //登录店铺的电话号码
    //     companyName, //登录店铺名称
    //     Search: "", //
    //     StartTime: this.filterCondition.createDate[0], //提交开始时间 （可选）
    //     EndTime: this.filterCondition.createDate[1], //提交结束时间 （可选）
    //     Name: this.filterCondition.name, //患者姓名
    //     PhoneNo: this.filterCondition.mobile, //电话号码
    //     ModeType, //问诊方式 全部=="",视频问诊==5，图文问诊==1
    //     SourceShop: this.filterCondition.sourceName, //来源门店
    //     InquiryStatus //状态 全部=="" , 等待接诊==1,接诊中==3,已开方==5,已拒绝==99
    //   }).then(res => {
    //     if (msg) {
    //       setTimeout(msg, 17);
    //     }
    //     if (res == "Again") {
    //       this.getInquiryList();
    //       return;
    //     }
    //     if (res.errcode == 0) {
    //       this.tableData = [];
    //       this.PageTotal = res.PageTotal;
    //       res.InquiryList.map(item => {
    //         this.tableData.push({
    //           GroupId: item.GroupId,
    //           inqStatus: item.Status,
    //           DealDesc: item.DealDesc,
    //           createTime: item.CreateDate,
    //           CompanyName: item.CompanyName,
    //           name: item.Name,
    //           sex: item.Sex == 1 ? "男" : "女",
    //           age: item.Age || "未填",
    //           mobile: item.PhoneNo,
    //           type: item.ModeType == 1 ? "图文问诊" : "视频问诊",
    //           InquiryId: item.InquiryId,
    //           status:
    //             item.Status == 1
    //               ? "等待接诊"
    //               : item.Status == 3
    //               ? "接诊中"
    //               : item.Status == 5
    //               ? "已开方"
    //               : "已拒绝"
    //           // render:function()
    //         });
    //       });
    //     } else {
    //       Toast("请求错误，请重试");
    //     }
    //     this.loading = false;
    //   });
    // },
    // 获取店铺列表
    getShopList() {
      var params = {
        shopId: getCookie("ShopId"),
        roleType: 0,
        pageIndex: 1,
        pageSize: 1000,
      };
      ShopList(params).then((res) => {
        if (res.code == 1) {
          res.data.list.map((item) => {
            item.ShopName == this.shopName
              ? (item.sel = true)
              : (item.sel = false);
            // item.extendType == 0? item.enterpriseName=item.enterpriseName+"(连锁总部)":item.extendType == 1?item.enterpriseName=item.enterpriseName+"(连锁门店)":item.enterpriseName=item.enterpriseName+"(单体药店)"
          });
          this.shopList = res.data.list;
        }
      });
    },
  },
  mounted() {
    this.getShopPac();
    // GetGroupMsg({
    //   inquiryId:"3663008251785216",
    //   token:localStorage.getItem("hToken"),
    //   method:4
    // }).then(res=>{
    // })
    this.$bus.$on("change", (item) => {
      this.checkStatus();
    });
    this.$bus.$on("againInquiry", (item) => {
      this.$store.commit("changeHisChat", false);
      this.changeDetail(this.consultationDetails);
    });

    localStorage.setItem("app_mobile", getCookie("mobile"));
    this.appMobilePhone = getCookie("mobile");
    localStorage.setItem("app_token", getCookie("access_token"));
    let tabNumber = sessionStorage.getItem("status");

    this.shopName = localStorage.getItem("companyName"); //原始数据
    this.shopType = localStorage.getItem("extendType");

    this.getShopList();
    this.getDocList();
    // getToken().then(res => {

    if (this.shopType && this.shopType == 0) {
      let abj = {
        title: "门店列表",
        status: 3,
      };
      this.GetAllList();
      // comObg = {
      //   title: "来源门店",
      //   key: "CompanyName",
      //   align: "center"
      // };
      this.totalShop = true;
      if (this.tabList.length == 5) {
        return false;
      }
      this.tabList.push(abj);
      // this.tableColumns.splice(6, 0, comObg);
    } else {
      this.tabList.map((item) => {
        if (item.title == "门店列表") {
          this.tabList.pop();
        }
      });
    }
    //   // this.getDocList();
    //   this.getInquiryList();
    //   this.getShopList();
    // });
    // if (tabNumber == 1) {
    //   this.tabIndex = tabNumber;
    //   this.page = 1;
    //   this.getInquiryList();
    // } else
    if (tabNumber == 0) {
      this.tabIndex = tabNumber;
    } else if (tabNumber == 2) {
      this.tabIndex = tabNumber;
    } else if (tabNumber == 4) {
      this.tabIndex = tabNumber;
    }
    let _this = this;
    this.uploadData.Token = localStorage.getItem("hToken");
  },
};
</script>
<style>
.look_all_info {
  color: red;
  margin-left: 10px;
  cursor: pointer;
}
td .ivu-btn > span {
  color: #378af1;
}
.ivu-steps .ivu-steps-tail i {
  height: 5px;
}
.ivu-steps-horizontal .ivu-steps-content {
  padding-left: 0 !important;
  margin-left: -10px;
  margin-top: 3px;
}
.change_btn {
  float: right;
  padding: 5px 15px;
  margin-right: 47px;
  text-align: center;
  border: 1px solid rgba(47, 49, 139, 1);
  border-radius: 4px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(47, 49, 139, 1);
}
.fill_edit {
  background: #2f318b;
  text-align: center;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: white;
  margin-bottom: 20px;
}
.edit_car {
  font-size: 18px;
  padding: 10px 0;
}
.inquiry_recording_search_spcel {
  height: 28px;
  background: #2f318b;
  border-radius: 4px;
  text-align: center;
  line-height: 28px;
  font-family: Microsoft YaHei;
  color: white;
  line-height: 28px;
  padding: 0 10px;
  position: absolute;
  right: 10px;
}
.qrcoe_size {
  position: absolute;
  top: 198px;
  left: 90px;
  border-radius: 40%;
}
</style>
<style lang="scss" scoped src="../scss/index.scss"></style>